import { smallScreen, mediumScreen, largeScreen } from '../../styles/variables';

export const SIZE_SMALL = smallScreen;
export const SIZE_MEDIUM = mediumScreen;
export const SIZE_LARGE = largeScreen;

export const HOVER = '(hover: hover)';
export const ANY_HOVER = '(any-hover: hover)';

export const POINTER_FINE = '(pointer: fine)';
export const POINTER_COARSE = '(pointer: coarse)';

export const ANY_POINTER_FINE = '(any-pointer: fine)';
export const ANY_POINTER_COARSE = '(any-pointer: coarse)';

export const POINTER_TYPE = {
    fine: 'fine',
    coarse: 'coarse',
    none: 'none',
};

export const HOVER_TYPE = {
    hover: 'hover',
    none: 'none',
};

export const VIEW_SIZE_TYPE = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'x-large',
};
